import { consoleRoutes } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink, Icon } from "@sagot/ui";
import type { components } from "@sagot/api-client";
import { useWorkspaceContext } from "../../../session/workspace-context";

type GapQuestion = components["schemas"]["GapQuestionView"];

/** "Questions in this cluster" (text + channel; each links to its conversation in the inbox). */
export function ClusterQuestions({ questions, fallback }: { questions: readonly GapQuestion[]; fallback: readonly string[] }) {
  const { t } = useTranslation();
  const { summary } = useWorkspaceContext();
  const items = questions.length > 0 ? questions : fallback.map((question) => ({ question, channel: null, conversation_id: null }));
  return (
    <div>
      <div className="label">{t("engage.gaps.sheet.questions")}</div>
      <ul className="space-y-1.5 text-sm">
        {items.map((item, index) => (
          <li key={`${item.question}-${String(index)}`} className="flex items-start gap-2 rounded-md bg-surface-2 px-3 py-2">
            <Icon name="message-square" className="mt-0.5 size-3.5 shrink-0 text-fg-subtle" />
            <span className="min-w-0 flex-1">{item.question}</span>
            {item.channel ? <span className="shrink-0 text-[11px] text-fg-subtle">{t(`engage.channels.${item.channel}`, { defaultValue: item.channel })}</span> : null}
            {item.conversation_id ? (
              <AppLink href={consoleRoutes.inbox(summary.slug, item.conversation_id)} className="-my-1 inline-flex size-6 shrink-0 items-center justify-center rounded-sm text-primary-ink hover:bg-sunken" aria-label={t("engage.gaps.sheet.viewChat")}>
                <Icon name="external-link" className="size-3.5" />
              </AppLink>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
